import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";

import { HelperService } from "src/app/services/helper.service";

import { TableColumn } from "src/app/models/table";
import { TobaccoItem, TobaccoModel, TobaccoPayload } from "src/app/models/tobacco";
import { TableColumnType } from "src/app/constants/table";
import { BooleanEnum } from "src/app/constants/boolean-enum";
import { TableService } from "src/app/services/table.service";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-tobacco-usage',
    templateUrl: './tobacco-usage.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TobaccoUsageComponent implements OnInit {
    @Input() public tobaccoModel: TobaccoModel;
    @Input() public hideWizardControl: boolean;
    @Output() public emitBack: EventEmitter<any> = new EventEmitter();
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<TobaccoPayload> = new EventEmitter();
    
    public booleanEnum = BooleanEnum;
    public tobaccoFormGroup: FormGroup;
    public tobaccoArrayName: string = 'tobaccoArray';
    public tobaccoItemData = new MatTableDataSource<TobaccoItem>();
    public smokerColumns: string[];
    public tobaccoColumns: TableColumn[];
    public isSingleQuestion: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
        private tableService: TableService,
    ){
    }

    ngOnInit(){
        this.isSingleQuestion = this.tobaccoModel.hideSmokerResponseMembers;

        if (this.isSingleQuestion) {
            this.tobaccoFormGroup = this.formBuilder.group({
                isSmoker: [null, Validators.required]
            });
        } else {
            this.tobaccoColumns = [
                {
                    columnName: 'Is Smoker',
                    propertyId: 'isSmoker',
                    columnType: TableColumnType.buttonToggle,
                    listArray: this.helperService.convertEnumToList(BooleanEnum),
                },
                {
                    columnName: 'Covered Member',
                    propertyId: 'coveredMemberName',
                    columnType: TableColumnType.label,
                },
                {
                    columnName: 'Relationship',
                    propertyId: 'relationship',
                    columnType: TableColumnType.label,
                },
            ];
            
            this.tobaccoItemData.data = this.tobaccoModel.coveredMembers.items;
            this.smokerColumns = this.tableService.extractTableColumnNames(this.tobaccoColumns);

            let l_FormArray: FormArray = new FormArray([]);
            this.tobaccoModel.coveredMembers.items.forEach((item: TobaccoItem) => {
                l_FormArray.push(
                    this.formBuilder.group({
                        systemNumber: [item.systemNumber],
                        coveredMemberName: [item.coveredMemberName],
                        relationship: [item.relationship],
                        isSmoker: [item.isSmoker, Validators.required],
                    })
                );
            });

            this.tobaccoFormGroup = this.formBuilder.group({
                [this.tobaccoArrayName]: l_FormArray
            });
        }
    }
    
    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitComplete(): void {
        let l_Payload = new TobaccoPayload();

        if (this.isSingleQuestion) {
            l_Payload.singleResponseIsSmoker = this.tobaccoFormGroup.get('isSmoker').value;
        } else {
            const l_Array = <FormArray>this.tobaccoFormGroup.get(this.tobaccoArrayName) as FormArray;
            l_Payload.coveredMemberQuestions = l_Array.value;
        }

        this.emitComplete.emit(l_Payload);
    }

    public back(): void {
        this.emitBack.emit();
    }
}
